'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.RP = exports.PS = exports.VS = exports.IR = exports.OSTATNI = exports.P = exports.ID = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-04-03T14:18:46Z                      #

// ##############################################################

/**
 * Typ dokladu. @author Pavel Stánek [pavel.stanek@marbes.cz] @since 26.01.2017
 */

/**
 * Občanský průkaz.
 */
var ID = exports.ID = 'ID';

/**
 * Cestovní doklad.
 */
var P = exports.P = 'P';

/**
 * Ostatní.
 */
var OSTATNI = exports.OSTATNI = 'OSTATNI';

/**
 * Povolení k pobytu.
 */
var IR = exports.IR = 'IR';

/**
 * Vízový štítek.
 */
var VS = exports.VS = 'VS';

/**
 * Pobytový štítek.
 */
var PS = exports.PS = 'PS';

/**
 * Řidičský průkaz.
 */
var RP = exports.RP = 'RP';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [ID, P, OSTATNI, IR, VS, PS, RP];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, ID, { caption: 'Občanský průkaz.' }), (0, _defineProperty3.default)(_params, P, { caption: 'Cestovní doklad.' }), (0, _defineProperty3.default)(_params, OSTATNI, { caption: 'Ostatní.' }), (0, _defineProperty3.default)(_params, IR, { caption: 'Povolení k pobytu.' }), (0, _defineProperty3.default)(_params, VS, { caption: 'Vízový štítek.' }), (0, _defineProperty3.default)(_params, PS, { caption: 'Pobytový štítek.' }), (0, _defineProperty3.default)(_params, RP, { caption: 'Řidičský průkaz.' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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